import React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";


export default function TopCustomersItem({ data, rate }) {

    return (
        <TableRow sx={{background: rate % 2 != 0 ? "#F4F4F0" : "#FFFFFF"}}>
            <TableCell>{rate}</TableCell>
            <TableCell sx={{fontWeight: "700", fontSize: "14px"}} >{data?.Name}</TableCell>
            <TableCell>{data?.Point}</TableCell>
        </TableRow>
    );
  }